import { TOGGLE_SIDEMENU } from 'shared/actions/app';
import { RootAction as Action } from 'shared/actions';

export interface State {
  visible: boolean;
}

export const sideMenu = (state: State = { visible: false }, action: Action): State => {
  switch (action.type) {
    case TOGGLE_SIDEMENU:
      return { visible: action.payload.visible };

    default:
      return state;
  }
};
